import { Check, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ExportOptionsDropdownProps } from '@/types';
import useTranslation from '@/hooks/useTranslation';

function ExportOptionsDropdown({
  exportOptions,
  selectedOption,
  setSelectedOption,
}: ExportOptionsDropdownProps) {
  const { lang } = useTranslation();

  return (
    <DropdownMenu onOpenChange={(open) => open}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="font-light border border-gray-300 justify-between max-w-64 w-full"
        >
          <span
            className="truncate overflow-hidden"
            title={lang.get(selectedOption ? selectedOption.label : 'msg.pleaseSelectExportOption')}
          >
            {lang.get(selectedOption ? selectedOption.label : 'msg.pleaseSelectExportOption')}
          </span>
          <ChevronDown className="w-4 h-4 ml-4 flex-shrink-0" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="max-w-64 w-full">
        {exportOptions?.map((option) => (
          <DropdownMenuCheckboxItem
            key={option.value}
            className={`px-3 text-sm cursor-pointers ${
              option.label === selectedOption?.label && 'bg-gray-200 cursor-auto text-dark-text'
            }`}
            onClick={() => setSelectedOption(option)}
          >
            {lang.get(option.label)}
            {option.value === selectedOption?.value && <Check className="w-4 h-4 ml-auto" />}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default ExportOptionsDropdown;
